import { Badge } from '@/components/ui/badge';
import type { AlertSeverity } from '../types';

export function SeverityBadge({ severity }: { severity: AlertSeverity }) {
  if (severity === 'critical') return <Badge variant="destructive">Critical</Badge>;
  if (severity === 'warning') return <Badge variant="warning">Warning</Badge>;
  return <Badge variant="muted">Info</Badge>;
}
